import { PageHighlight } from '../../../config/types';
import { setPageStateById } from '../PageContext';

export const addLoanHighlights = (setState: setPageStateById) => (loanHighlights: PageHighlight[]) => {
  setState('ADD_LOAN_HIGHLIGHTS', (s) => ({
    ...s,
    loanHighlights: [...s.loanHighlights, ...loanHighlights],
  }));
};
